import React, { useContext, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { TabTitle } from '../../../util/titleChanger'
import Loading from '../../../util/Loading'
import { deletePromotion, getPromotionsByDateRange } from '../../../action';
import { toast, ToastContainer } from 'react-toastify';
import { GlobalState } from '../../../GlobalState';
import ReactPaginate from 'react-paginate'

export default function PromotionDashboard() {
    TabTitle("Promotion Dashboard");
    const state = useContext(GlobalState);
    const signInUser = JSON.parse(localStorage.getItem('user_data'));

    const [promotions] = state.promotionAPI.promotions;
    const [promotionData, setPromotionData] = useState([]);

    //Import state
    const [rowPerPage] = state.promotionAPI.rowPerPage;
    const [pageNumber, setPageNumber] = state.promotionAPI.pageNumber;
    const [totalPages] = state.promotionAPI.totalPages;
    const [setSearch] = state.promotionAPI.search;
    const [callback, setCallback] = state.promotionAPI.callback;

    //Local value states
    let gotDate = new Date();
    let defaultDate = new Date(gotDate).toISOString().slice(0, 10);

    const [startDate, setStartDate] = useState(defaultDate)
    const [endDate, setEndDate] = useState(defaultDate);
    const [trigger, setTrigger] = useState(false)

    const pageNumberHandler = (data) => {
        let newPageNumber = data.selected + 1;
        setPageNumber(newPageNumber)
    }

    const searchHandler = (e) => {
        e.preventDefault();
        setPageNumber(1);
        setSearch(e.target.value ? e.target.value : "");
    }

    const searchByDateHandler = (e) => {
        e.preventDefault();
        setPageNumber(1);

        setTimeout(() => {
            setTrigger(true);
        }, 1000);

        e.target.name === "start_date" ? setStartDate(e.target.value) : setEndDate(e.target.value);
    }

    const onChangeSearchHandler = (start_date, end_date) => {
        getPromotionsByDateRange(rowPerPage, pageNumber, start_date, end_date, res => {
            setPromotionData(res);
            setPageNumber(res.totalPages ? res.totalPages : 1)
        })
    }

    const deletePromotionHandler = (id) => {
        deletePromotion(id, signInUser.id, res => {
            if (res.status === 200) {
                toast.success(res.data);
                setCallback(!callback)
            } else {
                toast.error(res.data);
                setCallback(!callback)
            }
        })
    }

    const dateConverter = (date) => {
        let convertedDate = new Date(date).toISOString().slice(0, 10);
        return convertedDate
    }

    useEffect(() => {
        setPromotionData(promotions);
        if (trigger) {
            onChangeSearchHandler(startDate, endDate);
            setTrigger(false);
        }
    }, [rowPerPage, pageNumber, promotions, trigger])

    return (
        <div className='form-container'>
            <div className="table">
                <div className="table_header">
                    <p>Promotion Details</p>
                    <div className='custom-search'>
                        <input
                            type="date"
                            name="start_date"
                            id="start_date"
                            value={startDate}
                            onChange={(e) => searchByDateHandler(e)}
                        />

                        <input
                            type="date"
                            name="end_date"
                            id="end_date"
                            value={endDate}
                            onChange={(e) => searchByDateHandler(e)}
                        />

                        <input
                            type="text"
                            name="search"
                            id="search"
                            placeholder='Search purchase here...'
                            onChange={(e) => searchHandler(e)}
                        />
                        <Link to='/promotion-form'><button className="add_new">+ Add New</button></Link>
                    </div>
                </div>

                {
                    promotionData.count === 0 ? <div className="loading-page-container"><Loading /></div>
                        : <div className="table_section">
                            <table>
                                <thead>
                                    <tr>
                                        <th>Promotion Code</th>
                                        <th>Promotion Tag</th>
                                        <th>Product Name</th>
                                        <th>Valid From</th>
                                        <th>Valid End</th>
                                        <th>Promotion Price</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        promotionData.count > 0 ? promotionData.data.map(promotion => (
                                            <tr key={promotion.id}>
                                                <td>{promotion.promotion_code}</td>
                                                <td>{promotion.tag}</td>
                                                <td>{promotion.product.name}</td>
                                                <td>{dateConverter(promotion.valid_from_date)}</td>
                                                <td>{dateConverter(promotion.valid_end_date)}</td>
                                                <td>Rs. {promotion.promotion_price}</td>
                                                <td>
                                                    <Link to={`/promotion-form/${promotion.id}`}><button><i className="uil uil-edit"></i></button></Link>
                                                    <Link to={"#"}></Link>
                                                    <button onClick={() => deletePromotionHandler(promotion.id)}><i className="uil uil-trash-alt"></i></button>
                                                </td>
                                            </tr>
                                        ))
                                            : <tr>
                                                <td colSpan={7}>Can not found any purchase details.</td>
                                            </tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                }

                <ReactPaginate
                    breakLabel="..."
                    nextLabel="next >"
                    onPageChange={pageNumberHandler}
                    marginPagesDisplayed={2}
                    pageCount={totalPages}
                    previousLabel="< previous"
                    renderOnZeroPageCount={null}
                    containerClassName='pagination'
                    pageLinkClassName='page-num'
                    previousLinkClassName='page-num'
                    nextLinkClassName='page-num'
                    activeLinkClassName='active-num'
                />
            </div>
            <ToastContainer />
        </div>
    )
}